import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { handleChunkLoadError, handleCSPErrors } from './utils/errorHandling'
import './utils/fetchInterceptor'

// エラーハンドリングを初期化
handleChunkLoadError();
handleCSPErrors();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
